export default __webpack_public_path__ + "i18n/translations/translation-th.8e8a5cbe.json";